export const formatProductPlanDefaultOffer = (defaultOffer?: number) => {
  if (defaultOffer === undefined || isNaN(defaultOffer)) {
    return undefined;
  }

  return `${Math.abs(defaultOffer)
    .toFixed(2)
    .replace(/\d$/, '') // remove last digit -- we only want one decimal place, but we _do not_ want to round
    .replace(/[.]0$/, '')}%`;
};
